var map = {
	"./arabic.json": 549,
	"./bulgarian.json": 550,
	"./czech.json": 551,
	"./denmark.json": 552,
	"./english.json": 553,
	"./finnish.json": 554,
	"./greek.json": 555,
	"./indonesian.json": 556,
	"./malay.json": 557,
	"./norwegian.json": 558,
	"./romanian.json": 559,
	"./slovakia.json": 560,
	"./swedish.json": 561
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156;


//////////////////
// WEBPACK FOOTER
// ./src/locales/gameknight ^\.\/.*\.json$
// module id = 156
// module chunks = 0